export default __webpack_public_path__ + "static/media/prizes.38f99932.png";